module.exports = __webpack_public_path__ + "static/media/Map.d9099931.png";